// src/utils/passwordValidation.js
//
// Single source of truth for password rules. Previously duplicated verbatim
// in CreateAccount.js and TrialSignup.js; extracted so the rules cannot drift
// between the screens where a password is created and where it is changed.
//
// Returns '' when valid, or a human-readable error string.
export const validatePassword = (password) => {
  if (password.length < 8) return 'Password must be at least 8 characters long';
  if (!/(?=.*[a-z])/.test(password)) return 'Password must contain at least one lowercase letter';
  if (!/(?=.*[A-Z])/.test(password)) return 'Password must contain at least one uppercase letter';
  if (!/(?=.*\d)/.test(password)) return 'Password must contain at least one number';
  return '';
};
